import Footer from "../components/LandingScreenComponents/Footer";
import HeaderCompact from "../components/LandingScreenComponents/HeaderCompact";

const RefundPolicy = () => {
  return (
    <div className="flex flex-col px-4 pt-4 sm:px-6 lg:px-12">
      {/* Header */}
      <HeaderCompact />

      {/* Refund Policy Content */}
      <div className="w-[96%] md:w-[60%] mx-auto">
        <div className="prose max-w-none text-gray-800">
          <h2 className="text-xl font-bold mb-2">Refund Policy</h2>
          <p className="mb-4">
            <strong>Effective Date:</strong> 25 September 2025
          </p>
          <p className="mb-2">
            This Refund Policy is part of and incorporated into the Terms of 
            Use governing your use of the Solvi mobile application and related services. 
            Any capitalized terms not defined in this document carry the same meaning as 
            outlined in the Terms of Use.
          </p>

          <h3 className="text-lg font-semibold mb-2">1. Subscription Cancellation</h3>
          <p className="mb-2">
            We understand that circumstances can change, and you may need to
            modify or end your subscription. Cancellation procedures depend on
            the platform through which your subscription was originally
            purchased:
          </p>
          <ul className="list-disc list-inside mb-4 space-y-1">
            <li>
              <strong>If you subscribed via the Solvi website:</strong> You can
              cancel your subscription at any time by contacting us at{" "}
              <a
                href="mailto:support@solvi.club"
                className="underline text-blue-600"
              >
                support@solvi.club
              </a>{" "}
              or using the cancellation link found in your confirmation or
              receipt email.
            </li>
            <li>
              <strong>If you subscribed via the Apple App Store:</strong> You
              will need to cancel your subscription through Apple’s system.{" "}
              <a
                href="https://support.apple.com/en-us/118428"
                target="_blank"
                rel="noopener noreferrer"
                className="underline text-blue-600"
              >
                Follow Apple’s steps here
              </a>
              .
            </li>
          </ul>
          <p className="mb-4">
            Note: Simply uninstalling the Solvi app does not cancel your subscription. 
            To stop recurring charges, you must cancel through the appropriate platform as described above.
          </p>

          <h3 className="text-lg font-semibold mb-2">2. Refund Eligibility</h3>
            <p className="mb-4">
            Refunds are subject to the platform used for the initial purchase:
          </p>


          
          <h4 className="font-semibold mb-1">
            2.1 Subscriptions via Apple App Store
          </h4>
          <p className="mb-4">
            If you purchased your subscription through the Apple App Store, Solvi cannot issue a refund directly. 
            Refund requests must be submitted to Apple following their refund policy, available here{" "}
            <a
              href="https://support.apple.com/en-us/118223"
              target="_blank"
              rel="noopener noreferrer"
              className="underline text-blue-600"
            >
              refund policy
            </a>
            .
          </p>
          <h4 className="font-semibold mb-1">
            2.2 Subscriptions via the Solvi Website
          </h4>
          <p className="mb-2">
            In general, subscription fees paid through the Solvi website are non-refundable, 
            and we do not provide credits or partial refunds for unused time.
          </p>
          <p className="mb-2">
            However, you may be eligible for a refund if the following conditions are met:
          </p>
          <ul className="list-disc list-inside mb-4 space-y-1">
            <li>
              The subscription was purchased directly from the Solvi website,
              and
            </li>
            <li>
              You request a refund by contacting{" "}
              <a
                href="mailto:support@solvi.club"
                className="underline text-blue-600"
              >
                support@solvi.club
              </a>{" "}
              within 30 days of the original purchase date.
            </li>
            <li>
                This refund policy also applies to subsequent renewals, 
                provided the refund request is submitted within 30 days of the charge.
            </li>
            <li>
                If your request meets the criteria, we will review it and notify you of our decision. 
                Approved refunds will be issued to your original payment method by our payment provider - Stripe.
            </li>
            <li>
                Please note: Due to the digital format of certain materials (such as downloadable workbooks), 
                these products are non-refundable once accessed or downloaded.
            </li>
          </ul>

          <h3 className="text-lg font-semibold mb-2">
            3. Managing Your Subscription and Account
          </h3>
          <p className="mb-4">
            To stop recurring charges or delete your account, you must cancel your subscription. 
            You can do this by following steps described in section 1 of that Refund Policy. 
            Again, removing the app from your device does not automatically stop billing.
          </p>

          <h3 className="text-lg font-semibold mb-2">
            4. Language and Interpretation
          </h3>
          <p className="mb-4">
            This policy is provided in English. Translations are offered solely for convenience. 
            In case of any conflict between the English version and a translated version, the English 
            version will take precedence.
          </p>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default RefundPolicy;
